/* eslint-disable no-restricted-globals */

export function makeStorageKey(...parts: (string | null | undefined)[]): string {
  return parts.filter(Boolean).join('-')
}

export const makeLocalStorageHandler = <T>(key: string, defaultData: T, expireAfter?: number) => {
  const get = () => {
    try {
      const stored = localStorage.getItem(key)
      if (stored) {
        const { data, expiration } = JSON.parse(stored) as { data: T; expiration: number }
        if (expiration && expiration < new Date().getTime()) {
          localStorage.removeItem(key)
          return defaultData
        }
        return data
      }
    } catch {
      /** That might happen, and it's not our problem */
    }
    return defaultData
  }

  const set = (data: T) => {
    try {
      const expiration = expireAfter ? new Date().getTime() + expireAfter : undefined
      localStorage.setItem(key, JSON.stringify({ data, expiration }))
    } catch {
      /** That might happen, and it's not our problem */
    }
  }
  const clear = () => {
    try {
      localStorage.removeItem(key)
    } catch {
      /** That might happen, and it's not our problem */
    }
  }

  return { get, set, clear }
}
